import { MetaTypeOverviewDtoMetaTypeEnum, ResourceTypeDto, ResourceTypeDtoMetaTypeEnum } from '@jooxter/api';

export class ResourceTypeRepository {
  static #instance: ResourceTypeRepository;
  #resourceTypes: Map<number, ResourceTypeDto> = new Map();

  /**
   * The static getter that controls access to the singleton instance.
   *
   * This implementation allows you to extend the Singleton class while
   * keeping just one instance of each subclass around.
   */
  public static get instance(): ResourceTypeRepository {
    if (!ResourceTypeRepository.#instance) {
      ResourceTypeRepository.#instance = new ResourceTypeRepository();
    }

    return ResourceTypeRepository.#instance;
  }

  public setResourceTypes(resourceTypes: ResourceTypeDto[]): ResourceTypeRepository {
    this.#resourceTypes = new Map(resourceTypes.map((rt) => [rt.id, rt]));
    return this;
  }

  public findAll(): ResourceTypeDto[] {
    return Array.from(this.#resourceTypes.values());
  }

  public hasResourceTypes(): boolean {
    return this.#resourceTypes.size > 0;
  }

  public findById(id: number): ResourceTypeDto | undefined {
    return this.#resourceTypes.get(id);
  }

  public findByMetaType(metaType: MetaTypeOverviewDtoMetaTypeEnum): ResourceTypeDto[] {
    return Array.from(this.#resourceTypes.values()).filter(
      (rt) => rt.metaType === (metaType as unknown as ResourceTypeDtoMetaTypeEnum)
    );
  }

  public findByMetaTypes(metaTypes: ResourceTypeDtoMetaTypeEnum[]): ResourceTypeDto[] {
    return Array.from(this.#resourceTypes.values()).filter(
      (rt) => rt.metaType !== undefined && metaTypes.includes(rt.metaType)
    );
  }
}
